import type { Vault } from '@/types/vault'

export function isVaultAboveMinScore(vault: Vault, minScore: number): boolean {
  if (minScore === 0) return true
  if (vault.score?.vaultScore == null) return false
  return vault.score.vaultScore >= minScore
}
